require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./mapping-a-user-armature-to-a-bunch-of-mini-drones.json") })
        }
      }, "path---mapping-a-user-armature-to-a-bunch-of-mini-drones");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---mapping-a-user-armature-to-a-bunch-of-mini-drones!./.cache/json/mapping-a-user-armature-to-a-bunch-of-mini-drones.json
// module id = 535
// module chunks = 231608221292675